import { Component, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { SubSink } from "subsink";
import { SharedDataService } from "../../../shared/sharedData.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { Subject } from "rxjs";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "template-details-layout",
    templateUrl: "./template-details-layout.component.html",
    standalone: false
})
export class TemplateDetailsLayoutComponent implements OnInit, OnDestroy {
    constructor(
        private _modalService: BsModalService,
        private _sharedDataService: SharedDataService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {}

    ngOnInit() {
        this._sharedDataService.setCss("timesheet");
    }

    ngOnDestroy() {}
}
